// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles/AddSupplierModal.module.css */
.AddSupplierModal_overlay__e7Gs3 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.AddSupplierModal_modal__g1klY {
  background: white;
  padding: 24px;
  border-radius: 12px;
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.AddSupplierModal_modal__g1klY input {
  padding: 8px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.AddSupplierModal_actions__0crj7 {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.AddSupplierModal_inputError__DHEye {
  border: 1px solid red;
}

.AddSupplierModal_error__wV6D4 {
  color: red;
  font-size: 12px;
  margin-top: -8px;
  margin-bottom: 8px;
}

.AddSupplierModal_headText__i49KD {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
}

.AddSupplierModal_cancel__Dlau3 {
  padding: 9px 20px;
  background: none;
  color: rgba(115, 115, 115, 1);
  border: 1px solid rgba(115, 115, 115, 1);
  border-radius: 4px;
  cursor: pointer;
}

.AddSupplierModal_save__9oVtc {
  padding: 9px 20px;
  background: rgba(29, 135, 82, 1);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Ошибка от сервера */
.AddSupplierModal_serverError__0CsmN {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ff4d4f;
  color: #fff;
  padding: 12px 20px;
  border-radius: 6px;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  animation: AddSupplierModal_slideUp__X01Oc 0.5s ease forwards;
  z-index: 1000;
}

/* Анимация появления снизу вверх */
@keyframes AddSupplierModal_slideUp__X01Oc {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* Остальная стилизация ошибок и инпутов */
.AddSupplierModal_inputError__DHEye {
  border: 1px solid #ff4d4f;
}

.AddSupplierModal_error__wV6D4 {
  color: #ff4d4f;
  font-size: 13px;
  margin-top: 4px;
}

`, "",{"version":3,"sources":["webpack://./src/styles/AddSupplierModal.module.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,6DAAqC;EACrC,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* styles/AddSupplierModal.module.css */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.modal input {\n  padding: 8px;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.actions {\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.inputError {\n  border: 1px solid red;\n}\n\n.error {\n  color: red;\n  font-size: 12px;\n  margin-top: -8px;\n  margin-bottom: 8px;\n}\n\n.headText {\n  font-weight: bold;\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.cancel {\n  padding: 9px 20px;\n  background: none;\n  color: rgba(115, 115, 115, 1);\n  border: 1px solid rgba(115, 115, 115, 1);\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.save {\n  padding: 9px 20px;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Ошибка от сервера */\n.serverError {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #ff4d4f;\n  color: #fff;\n  padding: 12px 20px;\n  border-radius: 6px;\n  font-weight: bold;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.2);\n  animation: slideUp 0.5s ease forwards;\n  z-index: 1000;\n}\n\n/* Анимация появления снизу вверх */\n@keyframes slideUp {\n  0% {\n    opacity: 0;\n    transform: translateX(-50%) translateY(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* Остальная стилизация ошибок и инпутов */\n.inputError {\n  border: 1px solid #ff4d4f;\n}\n\n.error {\n  color: #ff4d4f;\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `AddSupplierModal_overlay__e7Gs3`,
	"modal": `AddSupplierModal_modal__g1klY`,
	"actions": `AddSupplierModal_actions__0crj7`,
	"inputError": `AddSupplierModal_inputError__DHEye`,
	"error": `AddSupplierModal_error__wV6D4`,
	"headText": `AddSupplierModal_headText__i49KD`,
	"cancel": `AddSupplierModal_cancel__Dlau3`,
	"save": `AddSupplierModal_save__9oVtc`,
	"serverError": `AddSupplierModal_serverError__0CsmN`,
	"slideUp": `AddSupplierModal_slideUp__X01Oc`
};
export default ___CSS_LOADER_EXPORT___;
